// getSignedUrlHelper.js
import { generatePreSignedUrl } from "../api/userApi";

export const generateSignedUrl = async (
  fileName,
  folder = "meal-pictures",
  expiresIn = 600
) => {
  try {
    const { signedUrl } = await generatePreSignedUrl({
      filename: fileName,
      folder,
      isUploading: false
    });
    return signedUrl;
  } catch (error) {
    console.error("Error generating signed URL:", error);
    throw new Error("Failed to generate signed URL");
  }
};
